<template>
  <div class="switch-checkbox"
       :class="{
          'horizontal' : horizontal === true,
          'wider-gap' : widerGap === true
        }"
  >
    <input type="checkbox"
           class="switch-checkbox__input"
           :id="'switch-checkbox-' + id"
           :checked="checked"
           :disabled="disabled"
           @change="change"
    >
    <label
        class="switch-checkbox__label"
        :for="'switch-checkbox-' + id"
        v-bind:class="{'switch-checkbox__label--no-hover': noHover === true}"
    >
      <span class="switch-checkbox__label-txt"
        v-if="horizontal"
      >
        {{ label }}
      </span>
      <template v-else>
        {{label}}
      </template>

      <slot name="tooltip">

      </slot>

      <span class="switch-checkbox__ico" v-bind:class="{active: checked}"></span>
    </label>

    <div class="switch-checkbox__help-text">
      {{ helpText }}
    </div>

    <span class="switch-checkbox__error error-field" v-if="error && errorTxt">{{errorTxt}}</span>
  </div>
</template>

<script>
  export default {
    name: "SwitchCheckbox",

    data () {
      return {
        id: null,
        checked: this.value,
      }
    },

    props: [
      'label',
      'value',
      'helpText',
      'errorTxt',
      'error',
      'disabled',
      'horizontal',
      'widerGap',
      'noHover'
    ],

    mounted () {
      this.id = this._uid
    },

    methods: {
      changeCheckbox(val){
        this.$emit('change', val.target.value);
      },

      change: function() {
        // this.checked = !this.checked;
        this.$emit('input', !this.checked);
      }
    },

    watch: {
      value: function(newVal) {
        this.checked = newVal
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../../scss/mixins/mixins";
  @import "../../../../scss/colors";


  .switch-checkbox{
    display: flex;
    position: relative;

    &__input{
      display: none;
    }

    &.brown &__label{
      color: $brown;
    }

    &.fw-medium &__label{
      font-weight: 500;
    }

    &.table-head-style{

      font-size: 16px;
      line-height: 19px;
    }

    &__label{
      position: relative;
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      line-height: 16px;

      &--no-hover {
        cursor: initial;
      }
    }

    &__ico{
      position: relative;
      width: 26px;
      height: 16px;
      border: 1px solid $borderBrown;
      border-radius: 29px;
      display: block;
      margin-left: 15px;

      &:after{
        content: "";
        position: absolute;
        top: -1px;
        left: -1px;
        display: block;
        width: 16px;
        height: 16px;
        background: $brown;
        background: transparent;
        border: 1px solid $brown;
        border-radius: 50%;
        transition: 0.3s;
        opacity: .4;
      }

      &.active:after{
        left: 9px;
        background: $brown;
        border-color: $brown;
        opacity: 1;
      }
    }

    &__input:checked + &__label{
      &:before{
        background-color: #8F7A61;
        border-color: #8F7A61;
      }

      &:after{
        opacity: 1;
      }
    }

    &__input:disabled + &__label{
      color: $borderBrown;

      &:before{
        opacity: 0.4;
      }
    }

    &__help-text{
      position: absolute;
      top: 100%;
      left: 24px;
      font-size: 12px;
      line-height: 18px;
      color: #8F7A61;
    }

    &__error{
      position: absolute;
      bottom: -18px;
      left: 0;
      font-size: 11px;
      line-height: 13px;
      color: $orange;
    }

    &.horizontal{
      .switch-checkbox__label{
        padding-right: 30px;
        width: 100%;

        &:after{
          content: '';
          background: $brown;
          width: calc(100% - 30px);
          height: 1px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          opacity: 0.3;
        }
      }

      .switch-checkbox__ico{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 0;
      }

      .switch-checkbox__label-txt{
        font-size: 14px;
        line-height: 16px;
        font-weight: normal;
        color: $black;
        background: white;
        position: relative;
        z-index: 1;
        padding-right: 5px;
      }
    }

    &.wider-gap {
      .switch-checkbox__ico {
        margin-left: 32px;
      }
    }
  }

  .empty-label{
    min-height: 16px;
  }

</style>
